import { render, staticRenderFns } from "./DevDetails.vue?vue&type=template&id=df0fdac2&scoped=true&"
import script from "./DevDetails.vue?vue&type=script&lang=js&"
export * from "./DevDetails.vue?vue&type=script&lang=js&"
import style0 from "./DevDetails.vue?vue&type=style&index=0&id=df0fdac2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df0fdac2",
  null
  
)

export default component.exports